import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { UserState } from '../../shared/models'
import { useUserStore } from '../../shared/store/userStore'

interface Response {
    companyType: string
    userId: string
    role: string
    firstName: string
    lastName: string
    email: string
    companyStartYear: string
}

export const ImpersonationContainer = () => {
    const navigate = useNavigate()
    const updateAuthenticatedUser = useUserStore(state => state.updateAuthenticatedUser)

    const api = axios.create({
        baseURL: process.env.REACT_APP_SERVER_LOCATION,
    })

    useEffect(() => {
        api.get<Response>('/api/users/GetCurrentUserDetails', {
            headers: {
                'Accept-Language': 'hr-0',
            },
        }).then(result => {
            const user = result.data

            const newUser: UserState = {
                CompanyType: user.companyType,
                CompanyStartYear: user.companyStartYear,
                Email: user.email,
                FirstName: user.firstName,
                LastName: user.lastName,
                Role: user.role,
                UserId: user.userId,
                authenticated: true,
                UiLanguage: 'hr',
            }

            updateAuthenticatedUser(newUser)

            navigate('/')
        })
    }, [])

    return null
}
